<template>
  <div id="locations-list">
    <div v-if="locations && locations.items && locations.items.length === 0" class="tooltip-holder">
        <div class="tooltip tooltip--full tooltip--none"><p>No Locations Found</p></div>
    </div>
    <tc-table
        :dataList="locations"
        @filter="filter"
        :tbody="tbody"
        :settings="{
          externalFilters: {
            show: false
          },
          filters: {
            archived: {
              type: 'v-select',
              class: 'min-w-48',
              label: '',
              clearable: false,
              value: 'Active Locations',
              options: {
                text: 'name',
                value: 'id',
                items: [{
                  id: 'false',
                  name: 'Active Locations'
                }, {
                  id: 'true',
                  name: 'Archived Locations'
                }]
              }
            },
            q: {
              type: 'input',
              class: 'min-w-48',
              label: 'Search'
            },
          }
        }">

        <template slot="thead">
            <vs-th sort-key="name">Site Title</vs-th>
            <vs-th sort-key="category">Site Code</vs-th>
            <vs-th>Actions</vs-th>
        </template>

    </tc-table>
    <vs-button
      v-if="$hasPermission('edit:locations')"
      class="ml-auto mt-4"
      @click="$router.push('add-location')"
      icon-pack="feather"
      icon="icon-plus"
      icon-before>Add New Location</vs-button>
  </div>
</template>

<script>

import locationsTableBody from '@/components/tc-toble-body/Locations.vue';

export default {
  data () {
    return {
      tbody: {
        component: locationsTableBody
      },
      checkBox1: true,
      checkBox2: true,
      selected: [],
      // products: [],
      itemsPerPage: 10,
      isMounted: false,

      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {}
    };
  },
  computed: {
    locations () {
      return this.$store.state.visitManagement.locations;
    },
    currentPage () {
      if (this.isMounted) {
        return this.locations.paging.page;
      }
      return 0;
    },
    //products() {
    //  return this.$store.state.dataList.products
    //},
    queriedItems () {
      return this.$refs.table
        ? this.$refs.table.queriedResults.length
        : this.locations.items.length;
    }
  },
  methods: {
    checkOut () {},
    saveChanges () {},
    async filter (params) {
      const {archived} = params;
      console.log("params >>> ", params);
      await this.$store.dispatch('visitManagement/fetchLocations', {
        ...params,
        editable: true,
        archived: archived || false,
      });
    },
  },
  mounted () {
    this.isMounted = true;
  },
  created () {
    //var me = this;
    // this.$store.dispatch("visitManagement/fetchLocations").catch(
    // response => {console.log(response)},
    // err => {
    //   console.error(err);
    // });
  }
};
</script>
